// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"LoginPage_wrapper__1uza","img":"LoginPage_img__OaEo","links":"LoginPage_links__1Nb6","formWrapper":"LoginPage_formWrapper__269f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/LoginPage/LoginPage.scss
// module id = 1054
// module chunks = 0